<template>
    <div :class="isMobile == 0 ? '' : 'New_mobile'" class="New">
        <div :class="isMobile == 0 ? '' : 'New_box_mobile'" class="New_box">
            <div :class="isMobile == 0 ? '' : 'New_title_mobile'" class="New_title animate-fade-in"
                v-html="New.translations.title.content"></div>

            <!-- 轮播图容器：保持图片大小不变 -->
            <div class="carousel-container animate-fade-in">
                <img :class="isMobile == 0 ? '' : 'New_img_mobile'" class="New_img"
                    :src="'https://app.choisiyachts.com' + getImgeList(New.images[0].image_url)" />

                <!-- 轮播指示器（可选） -->
                <div class="carousel-indicators" v-if="New">
                    <span v-for="(item, idx) in New.images[0].image_url.split(',').length" :key="idx"
                        :class="{ active: idx === imgIndex }" @click="imgIndex = idx"></span>
                </div>
            </div>

            <!-- 手动切换按钮 -->
            <div class="New_change_img animate-fade-in">
                <img v-if="isMobile == 0" class="New_next_img" style="margin-right: 30px;" src="../assets/nextimg.png"
                    @click="imgChange(2)" />
                <img v-if="isMobile == 1" class="New_next_img" style="margin-right: 10px;" src="../assets/nextimg.png"
                    @click="imgChange(2)" />
                <img class="New_next_img" src="../assets/nexttimg.png" @click="imgChange(1)" />
            </div>

            <div class="New_content animate-fade-in" v-html="New.translations.content.content"></div>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
import { newDetail } from '../../request/api.js'
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'BrandStory',
    data() {
        return {
            lang: {},
            NewId: this.getUrlKey('id'),
            New: null,
            imgIndex: 0,
            carouselTimer: null, // 轮播定时器
            carouselInterval: 3000,// 轮播间隔（3秒）

            isMobile: 0
        }
    },
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true,
            immediate: true
        },
        // 图片索引变化时，重置定时器（避免手动切换后立即自动切换）
        imgIndex() {
            // this.resetCarouselTimer();
        }
    },
    mounted() {
        this.isMobile = localStorage.getItem('isMobile')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getNewsDetail('en');
        } else {
            this.getNewsDetail('zh');
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        this.clearCarouselTimer();
    },
    computed: {
        id() {
            return this.$route.params.id;
        }
    },
    methods: {
        getImgeList(string) {
            return string.split(',')[this.imgIndex]
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            // 语言切换时重新获取数据，同时重置轮播
            if (this.lang.fyType == 2) {
                this.getNewsDetail('en');
            } else {
                this.getNewsDetail('zh');
            }
        },
        imgChange(type) {
            if (!this.New) return;
            const imgCount = this.New.images[0].image_url.split(',').length;
            if (type == 1) {
                this.imgIndex = (this.imgIndex + 1) % imgCount; // 下一张
            } else {
                this.imgIndex = (this.imgIndex - 1 + imgCount) % imgCount; // 上一张
            }
        },
        getNewsDetail(language) {
            let data = {
                id: this.NewId,
                language
            }
            newDetail(data).then(res => {
                this.New = res.data;
                this.imgIndex = 0; // 重置图片索引
                // this.initCarouselTimer(); // 数据加载完成后初始化轮播
            }).catch(err => {
                console.log(err)
            })
        },
        getUrlKey(name) {
            return this.$route.params.id
        },
        // 初始化轮播定时器
        initCarouselTimer() {
            this.clearCarouselTimer(); // 先清除已有定时器
            this.carouselTimer = setInterval(() => {
                this.imgChange(1); // 自动切换到下一张
            }, this.carouselInterval);
        },
        // 清除轮播定时器
        clearCarouselTimer() {
            if (this.carouselTimer) {
                clearInterval(this.carouselTimer);
                this.carouselTimer = null;
            }
        },
        // 重置轮播定时器（手动切换后调用）
        resetCarouselTimer() {
            this.clearCarouselTimer();
            this.initCarouselTimer();
        }
    }
}
</script>

<style>
/* 原有样式保持不变 */
.New {
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
}

.New_mobile {
    height: 80%;
}

.New_box {
    width: 71%;
    margin: 60px auto;
    display: flex;
    flex-direction: column;
}

.New_box_mobile {
    margin-top: 20px;
    width: 94%;
}

.New_title {
    text-align: left;
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 28px;
    color: #021131;
    margin-bottom: 20px;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.New_title_mobile {
    font-size: 20px;
}

/* 轮播图容器：相对定位，用于承载指示器 */
.carousel-container {
    position: relative;
}

.New_img {
    width: 100%;
}

.New_img_mobile {
    margin-bottom: 10px;
    height: 200px;
}

/* 轮播指示器样式（可选） */
.carousel-indicators {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
}

.carousel-indicators span {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.carousel-indicators span.active {
    background-color: #6488C6;
    /* 与主题色一致 */
}

.New_change_img {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.New_next_img {
    width: 50px;
    height: 50px;
    cursor: pointer;
}

.New_content {
    letter-spacing: 1px;
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 18px;
    color: #021131;
    line-height: 25px;
    text-align: left;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

/* 浮现动画样式保持不变 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    opacity: 0;
    animation: fadeIn 0.8s ease-out forwards;
}

.New_title {
    animation-delay: 0s;
}

.carousel-container {
    animation-delay: 0.3s;
}

.New_change_img {
    animation-delay: 0.6s;
}

.New_content {
    animation-delay: 0.9s;
}
</style>